import classnames from 'classnames';
import styled from 'styled-components';

import { ButtonBase } from '#src/atoms/buttons/ButtonBase/index.tsx';
import { range } from '#src/lib/arrays.ts';

const Root = styled.div`
  --size: 6px;
  --padding: calc(var(--unit) / 2);
  --paddingBox: calc(var(--size) + 2 * var(--padding));
  display: flex;
`;
const Dot = styled(ButtonBase)`
  opacity: 0.3;
  padding: var(--padding);
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  &::before {
    content: '';
    display: block;
    background: currentColor;
    width: var(--size);
    height: var(--size);
    border-radius: var(--size);
    transition: all 0.2s ease-in-out;
  }
  &:hover {
    opacity: 0.8;
  }
  &.selected {
    opacity: 1;
  }
  &.small {
    --size: var(--half-unit);
  }
  &.collapsed {
    --padding: 0;
    --size: 0;
  }
  &.bars {
    opacity: 0.24;
    padding: var(--unit) calc(0.75 * var(--half-unit));
    &::before {
      width: var(--double-unit);
      height: var(--half-unit);
      border-radius: 2px;
    }
    &:hover {
      opacity: 0.6;
    }
    &.selected {
      opacity: 1;
      &::before {
        width: var(--quadruple-unit);
      }
    }
  }
`;

type Props = {
  titles: string[];
  selectedIndex: number;
  maxDotsToDisplay?: number;
  variant?: 'dots' | 'bars';
  setSelectedIndex: (index: number) => void;
};

export const Dots = ({
  selectedIndex,
  titles,
  setSelectedIndex,
  maxDotsToDisplay,
  variant = 'dots',
}: Props) => {
  if (titles.length < 1) {
    return null;
  }
  return (
    <Root>
      {range(titles.length).map((_, index) => {
        const title = titles[index];
        const visible =
          !maxDotsToDisplay ||
          (maxDotsToDisplay &&
            Math.abs(index - selectedIndex) < maxDotsToDisplay / 2) ||
          (selectedIndex < maxDotsToDisplay / 2 - 1 &&
            index < maxDotsToDisplay) ||
          (selectedIndex > titles.length - maxDotsToDisplay / 2 - 1 &&
            index > titles.length - maxDotsToDisplay - 1);
        return (
          <Dot
            // We need to use index and not slotname here as we reuse slots
            // oxlint-disable-next-line react/no-array-index-key
            key={index}
            title={title}
            className={classnames({
              bars: variant === 'bars',
              selected: index === selectedIndex,
              collapsed: !visible,
              small:
                maxDotsToDisplay &&
                Math.abs(index - selectedIndex) + 1 > maxDotsToDisplay / 2,
            })}
            onClick={() => setSelectedIndex(index)}
          />
        );
      })}
    </Root>
  );
};
